import classNames from "classnames";
import React, { useEffect, useState } from "react";

// outlinedButton
import outlinedButton from "./outlinedButton.module.scss";

export enum OutlinedButtonType {
  DEFAULT = "DEFAULT",
  DISABLED = "DISABLED",
  DISABLED_OUTLINED = "DISABLED_OUTLINED",
}

export enum OutlinedButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export interface OutlinedButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: OutlinedButtonType;
  backgroundColor?: string;
  color?: string;
  size?: OutlinedButtonSize;
  disableRipple?: boolean;
  width?: string;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({
  buttonType = OutlinedButtonType.DEFAULT,
  backgroundColor,
  color,
  disableRipple = false,
  size = OutlinedButtonSize["LARGE"],
  children,
  ...props
}: OutlinedButtonProps): JSX.Element => {
  const [buttonStyle, setButtonStyle] = useState<OutlinedButtonType>(
    OutlinedButtonType.DEFAULT
  );

  const [coords, setCoords] = useState({ x: -1, y: -1 });
  const [isRippling, setIsRippling] = useState(false);

  useEffect(() => {
    if (coords.x !== -1 && coords.y !== -1) {
      setIsRippling(true);
      setTimeout(() => setIsRippling(false), 300);
    } else setIsRippling(false);
  }, [coords]);

  useEffect(() => {
    if (!isRippling) setCoords({ x: -1, y: -1 });
  }, [isRippling]);

  useEffect(() => {
    if (props.disabled) {
      setButtonStyle(OutlinedButtonType.DISABLED);
    } else {
      setButtonStyle(buttonType);
    }
  }, [buttonType, props.disabled]);

  return (
    <button
      className={classNames(
        outlinedButton[`outlined_button_scss`],
        buttonStyle === OutlinedButtonType.DEFAULT &&
          outlinedButton["outlined_button_scss_default"],
        buttonStyle === OutlinedButtonType.DISABLED &&
          outlinedButton["outlined_button_scss_disabled"],
        buttonStyle === OutlinedButtonType.DISABLED_OUTLINED &&
          outlinedButton["outlined_button_outline_disabled"],
        outlinedButton[`outlined_button_scss_${size}`]
      )}
      style={{
        backgroundColor: backgroundColor || "",
        width: props.width || "100%",
        color: color || "",
      }}
      onClick={(e) => {
        if (!disableRipple) {
          const node = e.target as HTMLElement;
          const rect = node.getBoundingClientRect();
          setCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
        }
        props.onClick && props.onClick(e);
      }}
      {...props}>
      {isRippling ? (
        <span
          className={outlinedButton["ripple_outline"]}
          style={{
            left: coords.x,
            top: coords.y,
          }}
        />
      ) : (
        ""
      )}
      {children}
    </button>
  );
};

export default OutlinedButton;
